import swal from 'sweetalert'

export default {
    showOK,
    showErr,
    showConfirm,
}

function showOK(msg, title = 'Done') {
    swal(title, msg, 'success')
}

function showErr(msg, title = 'Error') {
    swal(title, msg, 'error')
}

// btn: true -> ok btn only
async function showConfirm(title, msg, icon, btn = true) {
    return await swal({
        title: title,
        text: msg,
        icon: icon,
        buttons: btn,
    })
}